export Project = '''
	id
	name
	slug
	city
	country
'''
